// import library
import axios from "axios";
import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CSVLink } from "react-csv";
import moment from"moment";
// import components
import Layout from "../../layouts/Layout";
import TableLoaderIcon from "../../components/Common/Icon/TableLoader";
import Pagination from "../../components/Common/Table/Pagination";
import LoaderIcon from "../../components/Common/Icon/Loader";
import FilterFormLayout from "../../components/Common/Table/FilterFormLayout";
import MonthDropDown from "../../components/Common/InputField/MonthDropDown";
import DateInputField from "../../components/Common/InputField/DateInputField";
import PaymentStatusCheckbox from "../../components/Common/InputField/PaymentStatusCheckbox";
// import files
import { env } from "../../env";
import SearchBar from "../../components/Common/Table/SearchBar";
import SortData from "../../components/Common/Table/SortData";

const OrderHistoryIndex = () => {
    // variables
    const { t } = useTranslation();
    const [isLoader, setIsLoader] = useState(true);
    const [isTableLoader, setIsTableLoader] = useState(false);
    const [orders, setOrders] = useState({
        "total_record": 0,
        "totalpages": 0,
        "list": []
    });
    const [rowCurrentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");
    const [sortBy, setSortBy] = useState('orderdate');
    const [sortOrder, setSortOrder] = useState("desc");
    const [showFilter, setShowFilter] = useState(false);
    const [showAction, setShowAction] = useState(false);
    const [actionKey, setActionKey] = useState(0);
    const formatter = new Intl.NumberFormat('de-DE', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
    const [filterInputs, setFilterInputs] = useState({
        month: "",
        createmonth: "",
        date: "",
        status: "Draft",
    });
    const csvData = [
        // ["Order Id", "Order Date", "Total Quantity", "Final Amount", "Comment", "Delivery Date", "Customer Id", "Order Status", "Stock Order Id", "Start Time", "End Time", "Customer Name", "Customer Lastname"],
        // ...orders.list.map(({ orderid, orderdate, totalqty, finalamount, comment, deliverydate, customerid, order_Status, stockorderid, starttime, endtime, customername, customerlastname }) => [
        //     orderid,
        //     orderdate,
        //     totalqty,
        //     finalamount,
        //     comment,
        //     deliverydate,
        //     customerid,
        //     order_Status,
        //     stockorderid,
        //     starttime,
        //     endtime,
        //     customername,
        //     customerlastname
        // ]),
    ];

    // functions
    useEffect(() => {
        const requestData = {
            page_num : rowCurrentPage,
            page_size : rowsPerPage,
            search_term : searchTerm,
            sort_by : sortBy,
            sort_order : sortOrder,
            month_info: filterInputs.createmonth,
            order_status: filterInputs.status,
            order_date: filterInputs.date
        }
        getOrderHistoryListApi(requestData);
    }, []);

    const getOrderHistoryListApi = async(data) => {
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        const headers = {
            "Accept" : "application/json",
            "Content-Type" : "application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.post(baseUrl+"/api/OfflineSync/GetOrderListSearch", data, {headers})
        .then((response) => {
            if(!response.data.success) {
                setOrders(response.data);
            }
            setIsLoader(false);
            setIsTableLoader(false);        
        }).catch((error) => {
            console.log(error);
        });
    };
    const handleCurrentPage = (page) => {
        setIsTableLoader(true);
        setOrders({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        setCurrentPage(page);
        const requestData = {
            page_num : page,
            page_size : rowsPerPage,
            search_term : searchTerm,
            sort_by : sortBy,
            sort_order : sortOrder,
            month_info: filterInputs.createmonth,
            order_status: filterInputs.status,
            order_date: filterInputs.date
        }
        getOrderHistoryListApi(requestData);
    };
    const handlePerPage = (row) => {
        setIsTableLoader(true);
        setOrders({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        setRowsPerPage(row);
        const requestData = {
            page_num : 1,
            page_size : row,
            search_term : searchTerm,
            sort_by : sortBy,
            sort_order : sortOrder,
            month_info: filterInputs.createmonth,
            order_status: filterInputs.status,
            order_date: filterInputs.date
        }
        getOrderHistoryListApi(requestData);
    };
    const handleSearchDataFromChild = (data) => {
        setIsTableLoader(true);
        setOrders({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        setSearchTerm(data);
        const requestData = {
            page_num : 1,
            page_size : rowsPerPage,
            search_term : data,
            sort_by : sortBy,
            sort_order : sortOrder,
            month_info: filterInputs.createmonth,
            order_status: filterInputs.status,
            order_date: filterInputs.date
        }
        getOrderHistoryListApi(requestData);
    };
    const handleSortDataFromChild = (data) => {
        setSortBy(data.field);
        setSortOrder(data.type);
        const requestData = {
            page_num : rowCurrentPage,
            page_size : rowsPerPage,
            search_term : searchTerm,
            sort_by : data.field,
            sort_order : data.type,
            month_info: filterInputs.createmonth,
            order_status: filterInputs.status,
            order_date: filterInputs.date
        }
        getOrderHistoryListApi(requestData);
    };
    const openAction = (e, index) => {
        e.preventDefault();
        if(actionKey === index) {
            setShowAction(!showAction);
        } else {
            setShowAction(true);
        }
        setActionKey(index);
    };
    const handleDateDataFromChild = (data) => {
        setFilterInputs({
            ...filterInputs,
            'date' : data
        });
    };
    const handleMonthDataFromChild = (data) => {
        if(data) {
            setFilterInputs({
                ...filterInputs,
                'month' : data.name,
                'createmonth' : data.id
            });
        } else {
            setFilterInputs({
                ...filterInputs,
                'month' : "",
                'createmonth' : ""
            });
        }
    };
    const handleStatusDataFromChild = (data) => {
        setFilterInputs({
            ...filterInputs,
            'status' : data.toString()
        });
    };
    const handleFilterSubmit = (e) => {
        e.preventDefault();
        setIsTableLoader(true);
        setOrders({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        const requestData = {
            page_num : 1,
            page_size : rowsPerPage,
            search_term : searchTerm,
            sort_by : sortBy,
            sort_order : sortOrder,
            month_info: filterInputs.createmonth,
            order_status: filterInputs.status,
            order_date: filterInputs.date
        }
        getOrderHistoryListApi(requestData);
        setShowFilter(!showFilter);
    };
    const clearData = (e) => {
        e.preventDefault();
        setIsTableLoader(true);
        setOrders({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        setFilterInputs({
            ...filterInputs,
            'month' : "",
            'createmonth' : "",
            'date': "",
            'status': "",
        });
        const requestData = {
            page_num : 1,
            page_size : rowsPerPage,
            search_term : searchTerm,
            sort_by : sortBy,
            sort_order : sortOrder,
            month_info: "",
            order_status: "Draft",
            order_date: ""
        }
        getOrderHistoryListApi(requestData);
        setShowFilter(!showFilter);
    };
    return  (
        <Layout>
            <div className="space-y-4">
                {/* first box */}
                <div className="flex justify-between items-center">
                    <div>
                        <h1 className="lg:text-2xl font-semibold capitalize">{ t('draft order') }</h1>
                        <p className="text-light-400 text-sm capitalize">{ t('orders') } / { t('draft order') }</p>
                    </div>
                    {/* <div className="flex items-center">
                        <CSVLink className="text-center px-2 lg:px-4 text-sm font-medium lg:text-base py-2 bg-white text-blue-normal border border-blue-normal rounded-lg tracking-wide capitalize" filename="orders.csv" data={csvData}>
                            { t('export') }
                        </CSVLink>
                        <div className="ml-4">
                            <a href="/orders/create/1">
                                <button className="text-center px-2 lg:px-4 text-sm font-medium lg:text-base py-2 text-white bg-blue-normal border border-blue-normal rounded-lg tracking-wide capitalize">{ t('create order') }</button>
                            </a>
                        </div>
                    </div> */}
                </div>
                { isLoader
                    ? 
                        <LoaderIcon />
                    :
                    <div className="p-4 bg-white border border-white rounded-lg">
                        {/* search bar and filter */}
                        <div className="relative">
                            <div className="flex justify-between items-center">
                                <SearchBar placeholder={ t('search by customer name')} term={searchTerm} setSearchDataFromChild={handleSearchDataFromChild}/>
                                <div className="flex items-center cursor-pointer bg-black-300 rounded-lg py-2 px-4" onClick={(e) => setShowFilter(!showFilter)}>
                                    <div>
                                        <img className="w-4" src="../../assets/icons/table/filter.svg" alt="filter" />
                                    </div>
                                    <div className="ml-2 text-blue-normal font-medium text-xl capitalize">{ t('filter')}</div>
                                </div>
                            </div>
                            {
                                showFilter 
                                ?
                                    <FilterFormLayout>
                                        <form onSubmit={handleFilterSubmit} autoComplete="off">
                                            <div className="px-4 space-y-3">
                                                <MonthDropDown monthValue={filterInputs.month} sendMonthDataFromChild={handleMonthDataFromChild} />
                                                <div>
                                                    <label className="font-medium capitalize">{ t('ordered date')}</label>
                                                    <DateInputField setDataFromChild={handleDateDataFromChild} startDate={null} dateInput={filterInputs.date} disableDate={false} week={[]}/>
                                                </div>
                                                <div className="flex items-center justify-end my-2">
                                                    <div>
                                                        <button onClick={(e) => clearData(e)} className="text-center px-2 lg:px-4 text-sm font-medium lg:text-base py-2 bg-white text-blue-normal border border-blue-normal rounded-lg capitalize">{ t('clear')}</button>
                                                    </div>
                                                    <div className="ml-4">
                                                        <button type="submit" className="text-center px-2 lg:px-4 text-sm font-medium lg:text-base py-2 text-white bg-blue-normal border border-blue-normal rounded-lg capitalize">{ t('apply')}</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </FilterFormLayout>
                                : null
                            }
                        </div>
                        {/* table */}
                        <div className="mt-4 relative w-full overflow-x-auto shadow-md rounded-lg">
                            <table className="w-full text-xs">
                                <thead className="text-gray-normal bg-background-normal">
                                    <tr>
                                        <th scope="col" className="font-normal p-4 w-1/5">
                                            <div className="flex">
                                                <div className="mr-2 uppercase">
                                                    { t('customer name') }
                                                </div>
                                                <SortData fieldName={'customername'} setSortDataFromChild={handleSortDataFromChild} />
                                            </div>
                                        </th>
                                        <th scope="col" className="font-normal p-4">
                                            <div className="flex">
                                                <div className="mr-2 uppercase">
                                                    { t('order number') }
                                                </div>
                                                <SortData fieldName={'orderid'} setSortDataFromChild={handleSortDataFromChild} />
                                            </div>
                                        </th>
                                        <th scope="col" className="font-normal p-4">
                                            <div className="flex">
                                                <div className="mr-2 uppercase">
                                                    { t('ordered date') }
                                                </div>
                                                <SortData fieldName={'orderdate'} setSortDataFromChild={handleSortDataFromChild} />
                                            </div>
                                        </th>
                                        <th scope="col" className="font-normal p-4">
                                            <div className="flex">
                                                <div className="mr-2 uppercase">
                                                    { t('quantity') }
                                                </div>
                                                <SortData fieldName={'totalqty'} setSortDataFromChild={handleSortDataFromChild} />
                                            </div>
                                        </th>
                                        <th scope="col" className="font-normal p-4">
                                            <div className="flex">
                                                <div className="mr-2 uppercase">
                                                    { t('order total') }
                                                </div>
                                                <SortData fieldName={'finalamount'} setSortDataFromChild={handleSortDataFromChild} />
                                            </div>
                                        </th>
                                        <th scope="col" className="font-normal p-4 uppercase text-left">
                                            { t('actions') }
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                { orders.list.length > 0 ?
                                    (orders.list).map((row, index) => (
                                        <tr key={'order'+row.orderid} className="bg-white border-b hover:bg-gray-50 ">
                                            <td className="p-4 text-light-400">
                                                {row.customername ? row.customername : 'NA'}
                                            </td>
                                            <td className="p-4 text-light-400">
                                                {row.orderid}
                                            </td>
                                            <td className="p-4 text-light-400">
                                                {row.orderdate ? moment(row.orderdate).format("DD/MM/YYYY") : 'NA'}
                                            </td>
                                            <td className="p-4 text-light-400">
                                                {formatter.format(row.totalqty)}
                                            </td>
                                            <td className="p-4 text-light-400">
                                                {formatter.format(row.finalamount)} €
                                            </td>
                                            <td className="p-4 relative">
                                                <div className="flex flex-col items-center">
                                                    <img className={showAction && actionKey === (row.orderid) ? "bg-background-normal p-3 rounded-full" : null + " cursor-pointer"} src="../../assets/icons/table/vertical-dot.svg" onClick={(e) => openAction(e, row.orderid)} alt="dot" />
                                                </div>
                                                {
                                                    showAction && actionKey === (row.orderid)
                                                    ? 
                                                        <div className="absolute w-max right-[4.5rem] top-5 bg-white border border-white shadow-md rounded">
                                                            <ul>
                                                                <li className="hover:bg-action-hover px-4 py-1.5 hover:rounded">
                                                                    <NavLink to={`/order/history/${row.orderid}`} className="capitalize flex">
                                                                        { t('view') }
                                                                    </NavLink>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    : null
                                                }
                                            </td>
                                        </tr>
                                    )) 
                                        : null
                                    }
                                </tbody>
                            </table>
                            {/* pagination */}
                            { isTableLoader
                                ?
                                    <TableLoaderIcon />
                                : (
                                    orders.list.length > 0 
                                    ?
                                        <Pagination
                                            currentPage={rowCurrentPage}
                                            totalCount={orders.total_record}
                                            pageSize={rowsPerPage}
                                            perPageCount={orders.list.length}
                                            onPageChange={page => handleCurrentPage(page)}
                                            onPageSizeChange={row => handlePerPage(row)}
                                        />
                                    : 
                                        <div className="py-4 text-center font-bold text-xs sm:text-xl capitalize">
                                                { t('no records available')}
                                        </div>
                                )
                            }
                        </div>
                    </div>
                }
            </div>
        </Layout>
    )
}

export default OrderHistoryIndex;